import { t } from '@lingui/macro';

import Panel from '../../page-framework/panel/PanelDecorator';
import { panelPropTypes, panelPropDefaults } from '../../page-framework/panel/PanelPropTypes';
import { timeRangeFilterId, userFilterId } from '../../filters';
import { COLUMN_TYPES } from '../../data-table/DataTableColumns';
import DataTable from '../../data-table/DataTable';
import { useQueryLoader } from '../../data-table/Loaders';
import { SORT_DESC } from '../../../utilities/FormUtilities';
import { FORMATTER_TYPES } from '../../../utilities/FormattingUtilities';

const title = `Audit Activities`;

const AUDIT_CLIENT_IP_FIELD = 'clientIP';
const AUDIT_CREATE_AT_FIELD = 'createdAt';
const AUDIT_USER_NAME_FIELD = 'userName';
const AUDIT_EVENT_FIELD = 'event';
const AUDIT_DETAILS_FIELD = 'details';

function getColumns() {
    return [
        {
            type: COLUMN_TYPES.TEXT,
            mapping: AUDIT_CREATE_AT_FIELD,
            title: t`Time`,
            sortable: true,
            width: 230,
            formatter: FORMATTER_TYPES.DATETIME,
        },
        {
            type: COLUMN_TYPES.TEXT,
            mapping: AUDIT_USER_NAME_FIELD,
            title: t`User`,
            sortable: true,
            width: 150,
        },
        {
            type: COLUMN_TYPES.TEXT,
            mapping: AUDIT_CLIENT_IP_FIELD,
            title: t`IP Address`,
            sortable: true,
            width: 200,
        },
        {
            type: COLUMN_TYPES.TEXT,
            mapping: AUDIT_EVENT_FIELD,
            title: t`Activity`,
            sortable: true,
            width: 400,
        },
        {
            type: COLUMN_TYPES.TEXT,
            mapping: AUDIT_DETAILS_FIELD,
            title: t`Details`,
            sortable: true,
            flex: 1,
        },
    ];
}

const dataSource = {
    url: '/query/admin/auditActivities',
    totalProperty: 'count',
    dataProperty: 'data',
    params: {
        searchFields: [AUDIT_EVENT_FIELD, AUDIT_CLIENT_IP_FIELD, AUDIT_USER_NAME_FIELD, AUDIT_DETAILS_FIELD],
    },
};

const initialSort = [{ property: AUDIT_CREATE_AT_FIELD, direction: SORT_DESC }];

function AuditActivityListPanel() {
    const loader = useQueryLoader(dataSource);
    return (
        <DataTable
            loader={loader}
            columns={getColumns()}
            tableId={'admin-audit-activity-list'}
            visibleRows={0}
            disableColumnRemover
            sorters={initialSort}
            params={{ csvPageSize: 100000, csvSequential: true }}
        />
    );
}

AuditActivityListPanel.propTypes = panelPropTypes;

AuditActivityListPanel.defaultProps = {
    ...panelPropDefaults,
    title,
    contentHeight: 175,
    minContentHeight: 175,
};

export default Panel({
    typeAlias: 'AuditActivityList',
    filters: {
        required: [timeRangeFilterId, userFilterId],
        optional: [],
    },
})(AuditActivityListPanel);
